/**
 * @generated SignedSource<<55c9214e6d10e859bb27252f65197e61>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_viewer" | "NavItem_viewer">;
  readonly " $fragmentType": "NavExpandingAreaItems_viewer";
};
export type NavExpandingAreaItems_viewer$key = {
  readonly " $data"?: NavExpandingAreaItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c019bf24700422c52c5db1003053f52d";

export default node;
